var map = {
	"./any-flush.png": 5887,
	"./big-win.png": 9951,
	"./bounty-winner.png": 7011,
	"./explosion.png": 1765,
	"./fireworks.png": 2186,
	"./first-flush.png": 9707,
	"./gold-coins.png": 8697,
	"./green-smoke.png": 5201,
	"./jackpot-winner.png": 7836,
	"./loader.png": 3443,
	"./royal-flush.png": 8724,
	"./straight-flush.png": 1853,
	"./winner.png": 5951,
	"assets/images/apng/any-flush.png": 5887,
	"assets/images/apng/big-win.png": 9951,
	"assets/images/apng/bounty-winner.png": 7011,
	"assets/images/apng/explosion.png": 1765,
	"assets/images/apng/fireworks.png": 2186,
	"assets/images/apng/first-flush.png": 9707,
	"assets/images/apng/gold-coins.png": 8697,
	"assets/images/apng/green-smoke.png": 5201,
	"assets/images/apng/jackpot-winner.png": 7836,
	"assets/images/apng/loader.png": 3443,
	"assets/images/apng/royal-flush.png": 8724,
	"assets/images/apng/straight-flush.png": 1853,
	"assets/images/apng/winner.png": 5951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5264;